import * as React from 'react';
import { useParams } from 'react-router-dom';
import PageMain from '../../components/Navigation/PageMain/PageMain';
import { useClientFields } from '../../sic-lib/api/hooks/useClientFields';
import { useGetViews } from '../../sic-lib/api/hooks/useViews';
import { DEFAULT_LIST_ID } from '../../sic-lib/defaults';
import { requestContacts, setListId } from '../../store/conversationGrid';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import Layout from './Layout/Layout';

export default function ConversationGridPage() {
    const dispatch = useAppDispatch();
    const { listId } = useParams<{ listId: string }>();

    const { isLoading, isError } = useClientFields();

    const { isLoading: isViewLoading, isError: isViewError } = useGetViews();

    const appliedListId = useAppSelector(state => {
        return state.conversationGrid?.listId || DEFAULT_LIST_ID;
    });

    React.useEffect(() => {
        const nextListId = +listId;

        if (appliedListId !== nextListId) {
            dispatch(setListId({ listId: nextListId }));
        }

        dispatch(requestContacts());
    }, [listId]);

    return (
        <PageMain
            pageTitle="Contacts"
            showError={isError || isViewError}
            showLoading={isLoading || isViewLoading}
        >
            <Layout listId={+listId} />
        </PageMain>
    );
}
